var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.863,
    height: 65.863,
    viewBox: "0 0 65.863 65.863",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_61",
    "data-name": "Groupe 61",
    transform: "translate(-19.129 -9.342)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 23.286,
    cy: 23.286,
    r: 23.286,
    transform: "translate(19.129 42.273) rotate(-45)",
    fill: "#b9c4e1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 9.059,
    cy: 11.71,
    rx: 9.059,
    ry: 11.71,
    transform: "translate(43.002 26.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_143",
    "data-name": "Trac\\xE9 143",
    d: "M78.4,125.31c-7.577,0-14.246,2.316-18.142,5.826a23.275,23.275,0,0,0,36.284,0C92.651,127.626,85.981,125.31,78.4,125.31Z",
    transform: "translate(-26.343 -74.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_267",
    "data-name": "Trac\\xE9 267",
    d: "M4.472,0h0A4.472,4.472,0,0,1,8.944,4.472v5.844s-2,4.472-4.472,4.472A4.472,4.472,0,0,1,0,10.316V4.472A4.472,4.472,0,0,1,4.472,0Z",
    transform: "translate(47.589 42.273)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_144",
    "data-name": "Trac\\xE9 144",
    d: "M83.418,87.737c.527,1.518.318,2.971-.467,3.244s-1.85-.737-2.377-2.256-.318-2.971.467-3.244S82.891,86.218,83.418,87.737Z",
    transform: "translate(-39.166 -48.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 2.911,
    cy: 1.506,
    rx: 2.911,
    ry: 1.506,
    transform: "translate(58.913 41.752) rotate(-70.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_145",
    "data-name": "Trac\\xE9 145",
    d: "M84.519,66.49c-1.177-2.141-2.388-4.413-2.328-6.855s1.92-5.021,4.362-4.932a7.225,7.225,0,0,0,1.275.049,5.214,5.214,0,0,0,2.155-1.319,5.741,5.741,0,0,1,5.478-.692c1.1.448,2.033,1.233,3.107,1.743a6.984,6.984,0,0,0,6.383-.259,3.623,3.623,0,0,1-1.871,1.662,3.458,3.458,0,0,0,2.263-.063,3.881,3.881,0,0,1-1.986,1.73l1.86.128a4.683,4.683,0,0,1-2.142,1.662l1.458.047a3.429,3.429,0,0,1-2.4,2.195l.94.013-3.08,4.443a3.93,3.93,0,0,1-1.031,1.135,3.683,3.683,0,0,1-1.2.43,30.1,30.1,0,0,1-9.29.6,5.685,5.685,0,0,1-3.015-.923,2.228,2.228,0,0,1-.715-2.82",
    transform: "translate(-40.386 -27.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_146",
    "data-name": "Trac\\xE9 146",
    d: "M94.121,124.943a26.28,26.28,0,0,1,.458-3.66,3.471,3.471,0,0,0,2.56.819l4.187.17c.163.952.276,2.072-.412,2.75a2.67,2.67,0,0,1-1.191.59,11.068,11.068,0,0,1-2.893.4c-1.158.008-2.539-.34-2.91-1.437l.377-.31",
    transform: "translate(-47.9 -71.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_147",
    "data-name": "Trac\\xE9 147",
    d: "M113.9,124.943a26.277,26.277,0,0,0-.458-3.66,3.473,3.473,0,0,1-2.561.819l-4.187.17c-.163.952-.276,2.072.412,2.75a2.669,2.669,0,0,0,1.191.59,11.063,11.063,0,0,0,2.892.4c1.158.008,2.539-.34,2.91-1.437l-.377-.31",
    transform: "translate(-56.005 -71.692)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.51e4fdb3d8a9e55e0877dde8addf868c.svg";
export { ForwardRef as ReactComponent };